import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Checkbox,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
  InputAdornment,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ClearIcon from '@mui/icons-material/Clear';
import FilterListIcon from '@mui/icons-material/FilterList';
import entertainment_entity_json from '../../../assets/json/entertainment_entity.json';
import { GameCssStyles } from '../GameCssStyles';
import MediaSelectDialog from './MediaSelectDialog';

const EntertainmentEntityDialog = ({ open, onClose, onSubmit, selectedItems }) => {

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: currentYear - 1949 }, (_, i) => 1950 + i);

  const [openMediaDialog, setOpenMediaDialog] = useState(false);
  const [selectedEntertainmentEntity, setSelectedEntertainmentEntity] = useState(null);
  const [selectedMedia, setSelectedMedia] = useState(null);

  const [searchText, setSearchText] = useState('');
  const [showFilter, setShowFilter] = useState(false);
  const [typeFilter, setTypeFilter] = useState('');
  const [filterValues, setFilterValues] = useState({});

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedConfig, setSelectedConfig] = useState();

  const [yearFrom, setYearFrom] = useState('');
  const [yearTo, setYearTo] = useState('');
  const [dynamicFilters, setDynamicFilters] = useState({});

  const { entertainment_entity_filter } = entertainment_entity_json;
  const [entertainment_entity_data, setEntertainmentEntity] = useState(entertainment_entity_json?.entertainment_entity_data);

  useEffect(() => {
    setFilterValues({});
  }, [typeFilter]);

  useEffect(() => {
    
  }, [selectedEntertainmentEntity]);

   useEffect(() => {
    const mergedData = entertainment_entity_json.entertainment_entity_data.map(entity => {
      const selected = selectedItems.find(sel => sel._id === entity._id);
      //console.log("selected : ",selected)
      return selected ? selected : entity;
    });
    setSelectedEntertainmentEntity(mergedData);

    const ids = selectedItems.map(item => item._id);
    //console.log("ids : ",ids)
    setSelectedIds(ids);
  }, [selectedItems]);

  const handleToggle = (_id) => {
    setSelectedIds((prev) =>
      prev.includes(_id) ? prev.filter((item) => item !== _id) : [...prev, _id]
    );
  };

  const isSelected = (_id) => selectedIds.includes(_id);

  const handleSubmit = () => {
    const selectedItems = entertainment_entity_data.filter((item) => selectedIds.includes(item._id));
    onSubmit?.(selectedItems, entertainment_entity_data);
    setFilterValues({});
    onClose();
  };

  const handleClearSearch = () => {
    setSearchText('');
  };

  // Optional: apply filters (just filter by one condition each for now)
  const applyFilters = (data, { itemType, filters, search }) => {
    //console.log("search : ", search)
    //console.log("filters : ", filters)
    return data.filter((item) => {
      const { type, displayName, multimedia, tags, metadata } = item;
      const typeMatch = !itemType || type === itemType;
      const searchMatch = !search || displayName.toLowerCase().includes(search.toLowerCase());

      // From filters
      const {
        isSuperStar: filterIsSuperStar,
        artistType: filterArtistType,
        industry: filterIndustry,
        language: filterLanguage,
        country: filterCountry,
        genre: filterGenre,
        show_yearFrom,
        show_yearTo,
      } = filters || {};

      // From metadata
      const {
        year: itemYear,
        language: itemLanguage,
        country: itemCountry,
        genre: itemGenre,
        artistType: itemArtistType,
        industry: itemIndustry,
        isSuperStar: itemIsSuperStar,
      } = metadata || {};

      //console.log("filterLanguage : ", filterArtistType, " : ", itemArtistType, " : ", (filterArtistType || filterArtistType === itemArtistType))

      // Apply all filters
      const filtersMatch = (
        (filterLanguage ? filterLanguage === itemLanguage : true) &&
        (filterCountry ? filterCountry === itemCountry : true) &&
        (filterIndustry ? Array.isArray(itemIndustry) && itemIndustry.includes(filterIndustry) : true) &&
        (filterArtistType ? filterArtistType === itemArtistType : true) &&
        (filterGenre ? filterGenre === itemGenre : true) &&
        (typeof filterIsSuperStar === 'boolean' ? filterIsSuperStar === itemIsSuperStar : true) &&
        (show_yearFrom ? parseInt(itemYear) >= parseInt(show_yearFrom) : true) &&
        (show_yearTo ? parseInt(itemYear) <= parseInt(show_yearTo) : true)
      );


      return (
        typeMatch &&
        searchMatch &&
        filtersMatch
      );
    });
  };

  const filteredData = applyFilters(entertainment_entity_data, {
    itemType: typeFilter,
    filters: filterValues,
    search: searchText
  });

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        fullScreen
        maxWidth="md"
        sx={{ m: 3 }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            m: 0,
            overflow: 'hidden',
          },
        }}
      >

        <DialogTitle sx={{
          px: 3,
          py: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 1,
        }}>
          {/* Title Row */}
          <Box sx={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography fontWeight="bold" sx={{ flex: 1, fontSize: 20 }}>
              Entertainment Entities
            </Typography>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
              <Box sx={{ flex: 0.9, mr: 2, mt: 1, mb: 0 }}>
                <TextField
                  fullWidth
                  label="Search by name"
                  variant="outlined"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  sx={GameCssStyles.formSingleLineTextField_sx}
                  InputProps={{
                    endAdornment: searchText && (
                      <InputAdornment position="end">
                        <IconButton onClick={handleClearSearch} size="small">
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Box>
              <Box sx={{ flex: 0.1 }}>
                <IconButton onClick={() => {
                  if (showFilter) {
                    setTypeFilter('');
                    setFilterValues({});
                  }
                  setShowFilter(!showFilter)
                }}>
                  <FilterListIcon />
                </IconButton>
                <IconButton onClick={() => {
                  console.log("clear")
                  setTypeFilter('');
                  setFilterValues({});
                  onClose()
                }}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent dividers={false} sx={{ p: 0 }}>

          <Box sx={{
            height: '100%',
            backgroundColor: '#f4f1f9',
            justifyContent: 'center',
            display: "flex",
            flex: 1,
            flexGrow: 1,
            flexDirection: "row",
            gap: 0,
          }}>
            <Box sx={{ m: 0, p: 2, height: '100%', width: '100%' }}>

              <Grid container spacing={2}
                sx={{
                  width: '100%',
                }}
              >
                {filteredData?.map((item) => (
                  <Grid key={item._id}>
                    <Box
                      sx={{
                        position: 'relative',
                        height: 140,
                        width: 240,
                        borderRadius: 2,
                        overflow: 'hidden',
                        //backgroundImage: `url(${item.multimedia.url})`,
                        backgroundColor: 'whitesmoke',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        padding: 1,
                        border: isSelected(item._id) ? '2px solid #1976d2' : '1px solid #ccc',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}
                      onClick={() => {
                        // if (item?.multimedia) {
                        //   setSelectedEntertainmentEntity(item);
                        //   //setOpenMediaDialog(true);
                        // }
                      }}
                    >
                      {/* Image thumbnail */}
                      <Box
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: 2,
                          overflow: 'hidden',
                          backgroundImage: `url(${item.multimedia?.[0]?.url})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          mr: 2,
                          flexShrink: 0,
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                        onClick={() => {
                        if (item?.multimedia) {
                          setSelectedEntertainmentEntity(item);
                          setOpenMediaDialog(true);
                          //setOpenMediaDialog(true);
                        }
                      }}
                      />

                      {/* Info area */}
                      <Box sx={{ flexGrow: 1 }}>
                        <Typography fontWeight="bold" sx={{ fontSize: 12 }}>
                          {item.displayName}
                        </Typography>
                        <Typography variant="body2" noWrap>
                          {item.genres?.join(', ') || 'N/A'}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {item?.type}
                        </Typography>
                      </Box>

                      {/* Top-right controls */}
                      <Box
                        sx={{
                          position: 'absolute',
                          top: 4,
                          right: 4,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                        }}
                      >
                        <Checkbox
                          checked={isSelected(item._id)}
                          onChange={() => handleToggle(item._id)}
                          size="medium"
                          sx={{
                            p: 0.5,
                            color: 'grey.700',
                            '&.Mui-checked': {
                              color: '#1976d2',
                            },
                          }}
                        />
                      </Box>

                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>

            {showFilter && (
              <Box
                sx={{
                  height: '100%',
                  width: '25%',
                  borderLeft: '1px solid #ccc',
                  borderTop: '1px solid #ccc',
                  borderBottom: '1px solid #ccc',
                  backgroundColor: '#f9f9f9',
                  p: 2,
                  ml: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>Filters</Typography>

                {/* Type Dropdown */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Type</InputLabel>
                  <Select
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                    label="Type"
                  >
                    <MenuItem value="">All</MenuItem>
                    {Object.keys(entertainment_entity_filter).map((type) => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                {/* Dynamic Filter Controls */}
                {typeFilter && entertainment_entity_filter[typeFilter] && (
                  <>
                    {Object.entries(entertainment_entity_filter[typeFilter]).map(([key, value]) => {
                      if (key === 'year_between' && value === true) {
                        return (
                          <Box key={key} sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>Year Range</Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                              <FormControl fullWidth>
                                <InputLabel>From</InputLabel>
                                <Select
                                  label="From"
                                  value={filterValues?.[`${typeFilter}_yearFrom`] ?? ''}
                                  onChange={(e) =>
                                    setFilterValues((prev) => ({
                                      ...prev,
                                      [`${typeFilter}_yearFrom`]: e.target.value,
                                    }))
                                  }
                                >
                                  {yearOptions.map((y) => (
                                    <MenuItem key={y} value={y}>{y}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>

                              <FormControl fullWidth>
                                <InputLabel>To</InputLabel>
                                <Select
                                  label="To"
                                  value={filterValues?.[`${typeFilter}_yearTo`] ?? ''}
                                  onChange={(e) =>
                                    setFilterValues((prev) => ({
                                      ...prev,
                                      [`${typeFilter}_yearTo`]: e.target.value,
                                    }))
                                  }
                                >
                                  {yearOptions.map((y) => (
                                    <MenuItem key={y} value={y}>{y}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Box>
                          </Box>
                        );
                      }

                      if (Array.isArray(value)) {
                        return (
                          <FormControl fullWidth sx={{ mb: 2 }} key={key}>
                            <InputLabel>{key}</InputLabel>
                            <Select
                              label={key}
                              value={filterValues[key] || ''}
                              onChange={(e) => {
                                setFilterValues((prev) => {
                                  const updated = { ...prev };
                                  const selectedValue = e.target.value;

                                  // If value is empty array or 'all' selected, remove the key
                                  if (!selectedValue || selectedValue.length === 0 || selectedValue === 'all') {
                                    delete updated[key];
                                  } else {
                                    updated[key] = selectedValue;
                                  }

                                  return updated;
                                })
                              }}
                            >
                              {value.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        );
                      }

                      if (typeof value === 'boolean' || value === 'true' || value === 'false') {
                        return (
                          <FormControlLabel
                            key={key}
                            control={
                              <Checkbox
                                checked={!!filterValues[key]}
                                onChange={(e) => {
                                  setFilterValues((prev) => {
                                    const updated = { ...prev };
                                    if (e.target.checked) {
                                      updated[key] = true;
                                    } else {
                                      delete updated[key];
                                    }
                                    return updated;
                                  });
                                }}
                              />
                            }
                            label={key}
                          />
                        );
                      }

                      return null;
                    })}
                  </>
                )}


                {/* Multimedia Dropdown */}
                {/* <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Multimedia</InputLabel>
                <Select
                  value={mediaFilter}
                  onChange={(e) => setMediaFilter(e.target.value)}
                  label="Multimedia"
                >
                  <MenuItem value="">All</MenuItem>
                  {entertainment_entity_filter.multimedia.map((media) => (
                    <MenuItem key={media} value={media}>
                      {media}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

                {/* Ratio Radio Buttons */}
                {/* <FormControl component="fieldset">
                <Typography variant="subtitle1">Aspect Ratio</Typography>
                <RadioGroup
                  value={ratioFilter}
                  onChange={(e) => setRatioFilter(e.target.value)}
                >
                  <FormControlLabel value="" control={<Radio />} label="All" />
                  {entertainment_entity_filter.ratio.map((ratio) => (
                    <FormControlLabel
                      key={ratio}
                      value={ratio}
                      control={<Radio />}
                      label={ratio}
                    />
                  ))}
                </RadioGroup>
              </FormControl> */}
              </Box>
            )}
          </Box>
        </DialogContent>

        <DialogActions dividers={false} sx={{ p: 0 }}>
          <Button variant="contained" fullWidth onClick={handleSubmit} sx={{ height: 50, fontSize: 16, fontWeight: '600', backgroundColor: 'burlywood', borderTopLeftRadius: 0, borderTopRightRadius: 0 }}>
            Submit
          </Button>
        </DialogActions>

      </Dialog>

      {selectedEntertainmentEntity && <MediaSelectDialog
        open={openMediaDialog}
        onClose={() => {
          setOpenMediaDialog(false)
          setSelectedMedia(null);
          setSelectedEntertainmentEntity(null);
        }}
        onSubmit={(media) => {
          //console.log("media : ", media);
          //console.log("selectedEntertainmentEntity : ", selectedEntertainmentEntity);

          setSelectedMedia(media?.[0]);
          setOpenMediaDialog(false);

          const areMultimediaEqual = (a = [], b = []) => {
            if (a.length !== b.length) return false;

            const aSorted = [...a].sort((x, y) => JSON.stringify(x).localeCompare(JSON.stringify(y)));
            const bSorted = [...b].sort((x, y) => JSON.stringify(x).localeCompare(JSON.stringify(y)));

            return JSON.stringify(aSorted) === JSON.stringify(bSorted);
          };

          const shouldUpdate = !areMultimediaEqual(selectedEntertainmentEntity?.multimedia, media);

          if (shouldUpdate) {
          const updatedItem = selectedEntertainmentEntity;
          updatedItem.multimedia = media;
          //console.log("updatedItem : ", updatedItem)
          setSelectedEntertainmentEntity((prev) => ({...prev,updatedItem}));
          setEntertainmentEntity((prevList) =>
            prevList.map((item) => (item._id === updatedItem._id ? updatedItem : item))
          );
          }
        }}
        selectedEntertainmentEntity={selectedEntertainmentEntity}
      />}
    </>
  );
};

export default EntertainmentEntityDialog;
